(function () {
  if (window.FGSFaqPageLoaded) return;
  window.FGSFaqPageLoaded = true;

  function normalize(value) {
    return String(value == null ? '' : value).trim().toLocaleLowerCase();
  }

  function highlightQuestion(element, query) {
    if (!element.dataset.originalText) element.dataset.originalText = element.textContent.trim();
    var original = element.dataset.originalText;
    element.textContent = '';
    if (!query) {
      element.textContent = original;
      return;
    }

    var lowerOriginal = normalize(original);
    var lowerQuery = normalize(query);
    var cursor = 0;
    var matchIndex = lowerOriginal.indexOf(lowerQuery, cursor);
    while (matchIndex !== -1) {
      element.append(document.createTextNode(original.slice(cursor, matchIndex)));
      var mark = document.createElement('mark');
      mark.textContent = original.slice(matchIndex, matchIndex + query.length);
      element.append(mark);
      cursor = matchIndex + query.length;
      matchIndex = lowerOriginal.indexOf(lowerQuery, cursor);
    }
    element.append(document.createTextNode(original.slice(cursor)));
  }

  function initFaqPage(root) {
    if (!root || root.dataset.faqReady === 'true') return;
    var input = root.querySelector('[data-faq-search]');
    var form = root.querySelector('[data-faq-search-form]');
    var searchIcon = root.querySelector('.faq-page__search-icon');
    var clearButton = root.querySelector('[data-faq-search-clear]');
    var categories = root.querySelector('[data-faq-categories]');
    var empty = root.querySelector('[data-faq-empty]');
    var editorEmpty = root.querySelector('[data-faq-editor-empty]');
    var status = root.querySelector('[data-faq-status]');
    if (!input || !form || !clearButton || !categories || !empty || !status) return;

    var categorySections = [];
    var categoryButtons = [];
    var items = [];
    var activeCategory = '';

    function collect() {
      categorySections = Array.from(document.querySelectorAll('[data-faq-category-section]'));
      var rootStyles = getComputedStyle(root);
      categorySections.forEach(function (section) {
        section.style.setProperty('--faq-accent', rootStyles.getPropertyValue('--faq-accent'));
        section.style.setProperty('--faq-highlight', rootStyles.getPropertyValue('--faq-highlight'));
      });
      items = categorySections.flatMap(function (section) {
        return Array.from(section.querySelectorAll('[data-faq-item]'));
      });

      items.forEach(function (item) {
        item.dataset.searchText = normalize(item.textContent);
        var question = item.querySelector('[data-faq-question]');
        if (question) question.dataset.originalText = question.textContent.trim();
      });

      if (!categorySections.some(function (section) { return section.dataset.faqCategoryId === activeCategory; })) {
        activeCategory = categorySections[0]?.dataset.faqCategoryId || '';
      }
    }

    function rebuildCategoryButtons() {
      categories.textContent = '';
      categoryButtons = categorySections.map(function (section) {
        var button = document.createElement('button');
        button.type = 'button';
        button.dataset.faqCategory = section.dataset.faqCategoryId;
        button.textContent = section.dataset.faqCategoryTitle;
        button.setAttribute('aria-pressed', String(section.dataset.faqCategoryId === activeCategory));
        categories.append(button);
        return button;
      });
    }

    function render(announce) {
      var query = normalize(input.value);
      var visibleCount = 0;
      var activeItemCount = 0;
      var visibleSections = [];

      categories.hidden = Boolean(query) || categorySections.length === 0;
      clearButton.hidden = !query;
      if (searchIcon) searchIcon.hidden = Boolean(query);
      if (editorEmpty) editorEmpty.hidden = categorySections.length > 0;

      categoryButtons.forEach(function (button) {
        button.setAttribute('aria-pressed', String(button.dataset.faqCategory === activeCategory));
      });

      categorySections.forEach(function (section) {
        var sectionId = section.dataset.faqCategoryId;
        var sectionItems = Array.from(section.querySelectorAll('[data-faq-item]'));
        var sectionVisibleCount = 0;
        if (sectionId === activeCategory) activeItemCount = sectionItems.length;

        sectionItems.forEach(function (item) {
          var searchMatch = !query || item.dataset.searchText.indexOf(query) !== -1;
          var visible = query ? searchMatch : sectionId === activeCategory;
          item.hidden = !visible;
          if (!visible) item.querySelector('details').open = false;
          if (visible) {
            visibleCount += 1;
            sectionVisibleCount += 1;
          }
          var question = item.querySelector('[data-faq-question]');
          if (question) highlightQuestion(question, query);
        });

        var sectionVisible = query ? sectionVisibleCount > 0 : sectionId === activeCategory && sectionItems.length > 0;
        section.hidden = !sectionVisible;
        section.classList.remove('is-last-visible');
        if (sectionVisible) visibleSections.push(section);
      });

      if (visibleSections.length) visibleSections[visibleSections.length - 1].classList.add('is-last-visible');

      var showSearchEmpty = Boolean(query) && visibleCount === 0;
      var showCategoryEmpty = !query && Boolean(activeCategory) && activeItemCount === 0;
      var showNoCategories = !query && categorySections.length === 0 && !editorEmpty;
      empty.hidden = !showSearchEmpty && !showCategoryEmpty && !showNoCategories;
      if (showSearchEmpty) empty.textContent = root.dataset.emptySearch;
      else if (showCategoryEmpty || showNoCategories) empty.textContent = root.dataset.emptyCategory;

      if (announce) {
        var resultLabel = visibleCount === 1 ? root.dataset.resultSingular : root.dataset.resultPlural;
        status.textContent = visibleCount + ' ' + resultLabel;
      }
    }

    function refresh(announce) {
      collect();
      rebuildCategoryButtons();
      render(Boolean(announce));
    }

    root.dataset.faqReady = 'true';
    root.fgsFaqRefresh = refresh;

    categories.addEventListener('click', function (event) {
      var button = event.target.closest('[data-faq-category]');
      if (!button) return;
      activeCategory = button.dataset.faqCategory;
      render(true);
    });
    form.addEventListener('submit', function (event) { event.preventDefault(); });
    input.addEventListener('input', function () { render(true); });
    input.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape' || !input.value) return;
      input.value = '';
      render(true);
    });
    clearButton.addEventListener('click', function () {
      input.value = '';
      render(true);
      input.focus();
    });

    refresh(false);
  }

  function initAll(scope) {
    var target = scope || document;
    if (target.matches && target.matches('[data-faq-page]')) initFaqPage(target);
    target.querySelectorAll?.('[data-faq-page]').forEach(initFaqPage);
  }

  function refreshAll() {
    document.querySelectorAll('[data-faq-page]').forEach(function (root) {
      if (root.fgsFaqRefresh) root.fgsFaqRefresh(false);
      else initFaqPage(root);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  else initAll(document);

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
    refreshAll();
  });
  document.addEventListener('shopify:section:unload', function () { setTimeout(refreshAll, 0); });
  document.addEventListener('shopify:section:reorder', refreshAll);
  document.addEventListener('shopify:section:select', function (event) {
    var section = document.querySelector('[data-faq-category-id="' + event.detail.sectionId + '"]');
    if (!section) return;
    var root = document.querySelector('[data-faq-page]');
    var input = root?.querySelector('[data-faq-search]');
    if (input) input.value = '';
    var button = root?.querySelector('[data-faq-category="' + event.detail.sectionId + '"]');
    if (button) button.click();
  });
  document.addEventListener('shopify:block:select', function (event) {
    var selected = Array.from(document.querySelectorAll('[data-faq-block-id]')).find(function (item) {
      return item.dataset.faqBlockId === event.detail.blockId;
    });
    if (!selected) return;
    var section = selected.closest('[data-faq-category-section]');
    var root = document.querySelector('[data-faq-page]');
    var input = root?.querySelector('[data-faq-search]');
    if (input) input.value = '';
    var button = root?.querySelector('[data-faq-category="' + section.dataset.faqCategoryId + '"]');
    if (button) button.click();
    selected.querySelector('details').open = true;
    selected.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });
})();
